import React, {
	createContext,
	useContext,
	useState,
	useCallback
} from "react";
import { postData } from "../services/api";
const ExecutiveContext = createContext();

export const ExecutiveProvider = ({
	children
}) => {
	const [surveyData, setSurveyData] = useState([]);
	const [loadingSurvey, setLoadingSurvey] = useState(false);
	const [totalSurveyCount, setTotalSurveyCount] = useState(0);
	const [answers, setAnswers] = useState([]);
	const [detailsId, setDetailsId] = useState(null);
	const [executiveDetails, setExecutiveDetails] = useState(null);
  
	const fetchSurveyOptions = useCallback(
		async ({
				keyword = "",
				sortQuery = {
					created_at: 1
				},
				type = "executive"
			} = {}) => {
				setLoadingSurvey(true);
				try {
					const result = await postData("employee-rating-option/list", {
						keyword,
						sortQuery,
						type,
					});
					if (result && result.data) {
						setSurveyData(result.data);
						setTotalSurveyCount(result.count || 0);
					}
					return result;
				} catch (err) {
					console.error("fetchSurveyOptions error:", err);
					throw err;
				} finally {
					setLoadingSurvey(false);
				}
			},
			[]
	);	
	const activeSurveyData = surveyData.filter((item) => item?.status === 1);
	return ( <ExecutiveContext.Provider value = {
			{
				surveyData,
				setSurveyData,
				activeSurveyData,
				fetchSurveyOptions,
				loadingSurvey,
				totalSurveyCount,
				answers,
				setAnswers,
				detailsId,
				setDetailsId,
				executiveDetails,
				setExecutiveDetails,
			}
		} >
		{
			children
		} </ExecutiveContext.Provider>
	);
};


export const useExecutive = () => useContext(ExecutiveContext);